import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PaymentMethodSelector from "./PaymentMethodSelector";
import PaymentForm from "./PaymentForm";
import ErrorMessage from "./ErrorMessage";
import { usePayment } from "../../hooks/usePayment";
import { CustomerData } from "../../../types";
import ThermalPrinterTest from "src/printConfigration/PrintConfigration";

interface Props {
  onClose: () => void;
  customerData: CustomerData;
  customerId: string;
  refetchLedger: () => void
}

const PaymentDrawer: React.FC<Props> = ({ onClose, customerData, customerId, refetchLedger }) => {
  const [amount, setAmount] = useState("0");
  const [paymentMethod, setPaymentMethod] = useState<"Cash" | "Buy on credit" | "">("");

  const { handlePayment, paymentLoading, print } = usePayment(
    customerData,
    customerId,
    onClose,
    refetchLedger
  );

  useEffect(() => { console.log(print) }, [print])

  const totalOutstandingBalance =
    customerData?.ledger?.reduce(
      (sum, item) => sum + (parseFloat(item.total_outstanding_balance) || 0),
      0
    ) || 0;

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (!value) return setAmount("0");

    if (value.startsWith("0") && value.length > 1) {
      value = value.replace(/^0+/, "");
    }

    const numericValue = Number(value);
    setAmount(
      numericValue > totalOutstandingBalance
        ? totalOutstandingBalance.toString()
        : value
    );
  };

  const handleFocus = () => {
    if (amount === "0") setAmount("");
  };

  const handleCancel = () => {
    onClose();
    setAmount("0");
    setPaymentMethod("");
  };

  const handleConfirm = () => {
    if (parseFloat(amount) > 0 && paymentMethod) {
      handlePayment(amount, paymentMethod);
    }
  };

  return (
    <div className="pay-drawer-overlay">
      <div className="pay-drawer" onClick={(e) => e.stopPropagation()}>
        <h2 className="pay-drawer-back">
          <ArrowBackIcon className="cursor-pointer" onClick={handleCancel} /> Repayment
        </h2>

        <PaymentMethodSelector selected={paymentMethod} onSelect={setPaymentMethod} />

        {customerData?.ledger?.length && totalOutstandingBalance > 0 ? (
          paymentMethod ? (
            <PaymentForm
              amount={amount}
              onAmountChange={handleAmountChange}
              onAmountFocus={handleFocus}
              onCancel={handleCancel}
              onConfirm={handleConfirm}
              paymentMethod={paymentMethod}
              Loading={paymentLoading}
            />
          ) : (
            <ErrorMessage id="pay-select-method-msg" message="Please select a payment method" />
          )
        ) : (
          <ErrorMessage id="pay-no-balance-msg" message="You have no outstanding balance" />
        )}

        {print && <ThermalPrinterTest ledgerPaid={print} openPrint={String(print)} />}
      </div>
    </div>
  );
};

export default PaymentDrawer;
